module.exports = __webpack_public_path__ + "img/15-gris.54d00233.png";